import { Component, Input, OnInit } from '@angular/core';
import { AndroidInterface } from 'src/app/models/android';
import { UiService } from 'src/app/services/ui.service';
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const Android: AndroidInterface;

@Component({
  selector: 'coupon-card',
  templateUrl: './coupon-card.component.html',
  styleUrls: ['./coupon-card.component.scss'],
})
export class CouponCardComponent implements OnInit {

  @Input() couponItem: any;

  constructor(private uiService: UiService) { }

  ngOnInit() {}

  async copyAndShop(item) {
    if(!item.no_coupon_code && typeof Android != 'undefined'){
      Android.onCopyToClipboard(item.code);
    }
    this.uiService.reloadPage(item.landingUrl);
  }
}
